/* =========================================================
   MAGNOLIA + SALT — motion layer for Horizon (library-free)
   Elegant scroll reveals via IntersectionObserver + CSS.
   No smooth-scroll hijacking, no GSAP — native scroll is
   left completely alone.
   ========================================================= */
(function () {
  'use strict';
  var root = document.documentElement;

  // If motion is reduced or IO is unavailable, leave everything
  // visible and untouched (no .mag-js class = no hidden start state).
  if (matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)) {
    return;
  }

  root.classList.add('mag-js');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mag-in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document
    .querySelectorAll('[data-mag-fade],[data-mag-reveal],[data-mag-split]')
    .forEach(function (el) { io.observe(el); });
})();

/* ---- Lock the "Clothing" top-level nav item ----
   The ladies want shoppers to choose a sub-category instead of landing on a big
   all-clothing page. Clicking the Clothing tab does nothing; its dropdown
   (desktop hover / mobile drawer list) still reveals Dresses, Tops, Sweaters, etc. */
(function () {
  function isClothing(a) {
    if (!a || !a.href) return false;
    try {
      var path = new URL(a.href, window.location.origin).pathname.replace(/\/+$/, '');
      return /\/collections\/clothing$/.test(path);
    } catch (e) { return false; }
  }
  var NAV_SEL = 'a.menu-list__link, a.menu-drawer__menu-item--mainlist';
  // Capture phase so navigation is stopped before any other handler runs.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest(NAV_SEL) : null;
    if (a && isClothing(a)) { e.preventDefault(); }
  }, true);
  // Polish: make the locked item read as a header rather than a link.
  function polish() {
    document.querySelectorAll(NAV_SEL).forEach(function (a) {
      if (isClothing(a)) {
        a.setAttribute('aria-haspopup', 'true');
        a.style.cursor = 'default';
      }
    });
  }
  if (document.readyState !== 'loading') polish();
  else document.addEventListener('DOMContentLoaded', polish);
  document.addEventListener('shopify:section:load', polish);
})();
